import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import flow from 'lodash/fp/flow';
import values from 'lodash/fp/values';
import filter from 'lodash/filter';
import sortBy from 'lodash/fp/sortBy';
import map from 'lodash/fp/map';
import keyBy from 'lodash/keyBy';
import { Option } from '@gcc/configurator';
import { hasTagValue } from '../utils/tags';
import { getStore } from '../store';
import { TConfiguratorOptions } from './_propTypes';
import SuperSku from './SuperSkuTemplate/SuperSkuContainer';

const hasHiddenTag = (option) => hasTagValue(option, 'pipfigurator', 'hidden');
const isValidOption = (option) => option.isActive
  && !option.isDependent && !option.isInternalOnly && !hasHiddenTag(option);
// const hasMultipleChoices = (option) => option.choices.length > 1;

const renderOptions =
  flow(values,
    filter((option) => isValidOption(option)),
    sortBy('sequence'),
    map((option) => {
      if (option.id) {
        return <Option key={option.id} option={option} store={getStore()} />;
      }
      return null;
    }));

const renderGroups = (groups, options) => {
  // future enhancement would be to make this more dynamic to render other groups besides supersku.
  return Object.values(groups).map((group) => {
    const { options: optionIds, name: groupName } = group;
    const optionsByGroups = keyBy(optionIds.map((optionId) => options[optionId]), 'id');
    return groupName === 'SuperSku'
      ? <SuperSku renderOptions={renderOptions} options={optionsByGroups} />
      : renderOptions(optionsByGroups);
  });
};

const Layout = ({ canRender, isSuperSku, options, groups }) => {
  if (canRender) {
    return isSuperSku ? renderGroups(groups, options) : renderOptions(options);
  }
  return null;
};

Layout.propTypes = {
  options: PropTypes.objectOf(TConfiguratorOptions).isRequired,
  groups: PropTypes.objectOf(TConfiguratorOptions).isRequired,
  canRender: PropTypes.bool.isRequired,
  isSuperSku: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
  const { configurator: { options, groups } } = state;
  const canRender = !isEmpty(options.allIds) || !isEmpty(groups);
  const isSuperSku = !isEmpty(filter(groups, (group) => group.name.toLowerCase() === 'supersku'));
  return {
    canRender,
    isSuperSku,
    groups,
    options
  };
};

const options = {
  areOwnPropsEqual: (prev, next) => isEqual(prev, next),
  areStatePropsEqual: (prev, next) => isEqual(prev, next),
  areMergedPropsEqual: (prev, next) => isEqual(prev, next),
};

export default withTheme(connect(mapStateToProps, null, null, options)(Layout));
